<template>
  <v-container id="hanovers" fluid tag="section">
    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="light-blue" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <!-- <v-list>
          <v-list-item :to="'/handover/create'">
            <v-list-item-title>{{ $i18n.t("Create") }}</v-list-item-title>
          </v-list-item>
        </v-list>-->
      </v-menu>
    </div>

    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card
          color="light-blue"
          icon="mdi-filter"
          class="px-3 py-1 small-icon"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn color="black" class="mr-0" fab small text @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" md="3">
              <z-vehicle-select class="purple-input" v-model="filters.vehicle_id" />
            </v-col>
            <v-col cols="12" md="3">
              <z-driver-select
                class="purple-input"
                v-model="filters.fromDriver"
                :label="$i18n.t('From Driver')"
              />
            </v-col>
            <v-col cols="12" md="3">
              <z-driver-select
                class="purple-input"
                v-model="filters.toDriver"
                :label="$i18n.t('To Driver')"
              />
            </v-col>
            <v-col cols="12" md="3">
              <z-supervisor-select
                class="purple-input"
                v-model="filters.toSupervisor"
                :label="$i18n.t('To Supervisor')"
              />
            </v-col>

            <v-col cols="12" md="2" class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    fab
                    text
                    small
                    @click="clear(1)"
                    style="margin-right:10px !important"
                    v-on="on"
                  >
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                fab
                small
                dark
                @click="search()"
                :loading="loading"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width:100%"
      :loading="loading"
    >{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card
      icon="mdi-domain"
      :title="$i18n.t('Handovers')"
      class="px-5 py-3"
      v-if="grid.records"
    >
      <z-grid-record :grid="grid" />
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text"></th>
            <th class="primary--text">{{ $i18n.t("Vehicle ") }}</th>
            <th class="primary--text"></th>
            <th class="primary--text">{{ $i18n.t("From Driver") }}</th>
            <th class="primary--text">{{ $i18n.t("Assigned To") }}</th>
            <th class="primary--text">{{ $i18n.t("Status/Time ") }}</th>
            <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="hand in grid.rows" :key="hand._id">
            <td>
              <v-img v-if="hand.vehicle" src="hand.vehicle.pic" />
            </td>
            <td>
              <span v-if="hand.vehicle">
                <b>{{hand.vehicle.regNo}}</b>
              </span>
              <br />
              <span v-if="hand.vehicle">({{hand.vehicle.owner}})</span>
              <br />
              <span v-if="hand.vehicle">
                {{hand.vehicle.vehicleType}}
                <br />
              </span>
            </td>
            <td>
              <v-img v-if="hand.from_driver" src="hand.from_driver.pic" />
            </td>
            <td>
              <span v-if="hand.from_driver">
                <span v-if="hand.from_driver.name">
                  {{hand.from_driver.name}}
                  <br />
                </span>
                <span>
                  <span class="fa fa-phone"></span>
                  <b>{{hand.from_driver.countryCode}} - {{hand.from_driver.phone}}</b>
                  <br />
                </span>
                <span v-if="hand.from_driver.email">
                  <span class="fa fa-envelope"></span>
                  {{hand.from_driver.email}}
                  <br />
                </span>
              </span>
            </td>
            <td>
              <span v-if="hand.to_driver">
                <span class="fa fa-user"></span>
                <span v-if="hand.to_driver.name">
                  {{hand.to_driver.name}}
                  <br />
                </span>
                <span>
                  <span class="fa fa-phone"></span>
                  <b>{{hand.to_driver.countryCode}} - {{hand.to_driver.phone}}</b>
                  <br />
                </span>
                <span v-if="hand.to_driver.email">
                  <span class="fa fa-envelope"></span>
                  {{hand.to_driver.email}}
                </span>
              </span>
              <span v-if="hand.to_supervisor">
                <span class="icon-education-031"></span>
                <span title="Supervisor Name" v-if="hand.to_supervisor.name">
                  {{hand.to_supervisor.name}}
                  <br />
                </span>
                <span>
                  <span class="fa fa-phone"></span>
                  <b>{{hand.to_supervisor.countryCode}} - {{hand.to_supervisor.phone}}</b>
                  <br />
                </span>
                <span v-if="hand.to_supervisor.email">
                  <span class="fa fa-envelope"></span>
                  {{hand.to_supervisor.email}}
                  <br />
                </span>
              </span>
            </td>
            <td>
              {{hand.statusStr}}
              <br />
              {{hand.at | moment("DD MMM YYYY hh:mm a")}}
            </td>
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="float-right"
                    color="primary"
                    small
                    fab
                    text
                    dark
                    :to="'/handover/' + hand._id"
                    v-on="on"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class TaxSlabs extends Vue {
  grid = { page: 0 };
  rows = 20;
  url = "/api/handover/vehicle/grid?rows=" + this.rows;
  showFilter = false;
  name = "";
  menu1 = false;
  filterUrl = "";
  country = "";
  city = "";
  on = null;
  page = 1;
  filters = {
    vehicle_id: null,
    fromDriver: null,
    toDriver: null,
    toSupervisor: null,
    status: null,
  };

  get loading() {
    return common.loading;
  }

  async mounted() {
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.filters.vehicle_id)
      this.filterUrl += "&vehicle_id=" + this.filters.cvehicle_id;
    if (this.filters.fromDriver)
      this.filterUrl += "&fromDriver=" + this.filters.fromDriver;
    if (this.filters.toDriver)
      this.filterUrl += "&toDriver=" + this.filters.vtoDriver;
    if (this.filters.toSupervisor)
      this.filterUrl += "&toSupervisor=" + this.filters.toSupervisor;
    if (this.filters.status)
      this.filterUrl += "&qualityCheck.status=" + this.filters.status;
    common.setLoading(true);
    await this.showPage(1);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.btn-list-item {
  padding: 0;
  float: left !important;
}
.btn-list-item .v-btn--text {
  padding: 0;
  text-transform: none;
  font-size: 14px;
  float: left;
  margin: 0;
}
</style>
